var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTalks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5805 7.66326C12.5805 10.189 10.1463 11.9571 7.5013 11.9571C4.8563 11.9571 2.42214 10.189 2.42214 7.66326H0.792969C0.792969 10.5342 3.39964 12.9084 6.54297 13.321V16.0825H8.45964V13.321C11.603 12.9084 14.2096 10.5342 14.2096 7.66326H12.5805ZM6.3513 2.52752C6.3513 1.97185 6.8688 1.51721 7.5013 1.51721C8.1338 1.51721 8.6513 1.97185 8.6513 2.52752L8.64172 7.74745C8.64172 8.30312 8.1338 8.75776 7.5013 8.75776C6.8688 8.75776 6.3513 8.30312 6.3513 7.74745V2.52752ZM7.5013 10.189C8.2638 10.189 8.99507 9.92292 9.53424 9.44925C10.0734 8.97558 10.3763 8.33314 10.3763 7.66326V2.61171C10.3763 1.94183 10.0734 1.29939 9.53424 0.82572C8.99507 0.352045 8.2638 0.0859375 7.5013 0.0859375C6.73881 0.0859375 6.00754 0.352045 5.46837 0.82572C4.9292 1.29939 4.6263 1.94183 4.6263 2.61171V7.66326C4.6263 8.33314 4.9292 8.97558 5.46837 9.44925C6.00754 9.92292 6.73881 10.189 7.5013 10.189Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalks);
export default __webpack_public_path__ + "static/media/talks.e2557cef.svg";
export { ForwardRef as ReactComponent };